/**
 * @file paddle hack light
 * @author wanzhongyun
 */

import React from 'react';
import { IHackLight } from './../../type';
// import Video from './../../../../components/video-modal/Video';

import './style.less';


const HackLight: React.FC<IHackLight> = props => {

    const {
        titleImageUrl,
        contentImageUrl,
        // videoLink,
        // videoPoster
    } = props;

    // const videoRef = useRef<HTMLVideoElement>(null);
    // const playRef = useRef<HTMLDivElement>(null);
    // const [playStatus, setPlayStatus] = useState<boolean>(false);

    // const handleVideoClick = () => {
    //     // 还需要做个判断
    //     if (videoRef.current && playRef.current && !playStatus) {
    //         setPlayStatus(true);
    //         videoRef.current.play();
    //         playRef.current.style.display = 'none';
    //     }
    // };
    
    return (
        <div className='paddle-hack-light-wrapper'>
            <img className='paddle-hack-light-title' src={titleImageUrl} alt='' />
            <img className='paddle-hack-light-content' src={contentImageUrl} alt='' />
            {/* <div onClick={handleVideoClick} className='paddle-hack-light-click'>
                <Video
                    className='paddle-hack-light-video'
                    width={1200}
                    height={500}
                    poster={videoPoster}
                    ref={videoRef}
                    controls
                    src='https://paddle-site-web-video.cdn.bcebos.com/videoworks/mda-kdpm7vwbsk8f4cui/paddle_site_video/源文件/b秒懂飞桨-轻松风格20191209.mp4'
                />
                <div className='paddle-hack-light-control'>
                    <span className='paddle-hack-light-video-play' ref={playRef} />
                </div>
            </div> */}
            
        </div>
    );
};

export default HackLight;